import { Component, OnInit } from '@angular/core';
import { WeekMonitoringsheetKpiComponent } from '@component/kpi/planning/week-monitoringsheet-kpi/week-monitoringsheet-kpi.component';
import { StatusKpiDto } from '@model/kpi/pie-status-kpi-dto';
import { DashboardService } from '../../../dashboard/services/dashboard.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { TranslateModule } from '@ngx-translate/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCardModule } from 'ng-zorro-antd/card';

@Component({
  selector: 'app-dashboard-monitoring-sheet-kpi',
  imports: [
    TranslateModule,
    WeekMonitoringsheetKpiComponent,
    NzSpinModule,
    NzCardModule
  ],
  templateUrl: './dashboard-monitoring-sheet-kpi.component.html',
  styleUrl: './dashboard-monitoring-sheet-kpi.component.scss',
})
export class DashboardMonitoringSheetKpiComponent implements OnInit {

  /**
   * Loading state
   *
   * @public
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Status KPI data
   *
   * @public
   * @type {StatusKpiDto[]}
   */
  public statusKpi: StatusKpiDto[] = [];

  constructor(
    private readonly _dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this._dashboardService.countMonitoringSheetStatusFromLastThreeMonths()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (data) => {
          this.statusKpi = [...data];
        },
        error: () => {

        }
      });
  }

}